"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityType = void 0;
var EntityType;
(function (EntityType) {
    EntityType["VENDOR"] = "Vendor";
    EntityType["CONTACT"] = "Contact";
    EntityType["EMPLOYEE"] = "Employee";
    EntityType["CUSTOM_JOB"] = "CustJob";
    EntityType["UNKNOWN"] = "Unknown";
})(EntityType || (exports.EntityType = EntityType = {}));
